/* global locales */
import angular from 'angular';
import 'angular-bootstrap';
import locales from '../../locale';
import './competitionsServices';

'use strict';

const competitionsControllers = angular.module('applicationModule.competitionsControllers', [
    'applicationModule.competitionsServices',
    'ui.bootstrap'
]);

// Competitions Controllers
competitionsControllers.controller('CompetitionsListController', ['$scope', '$rootScope', '$stateParams', 'NgTableParams', 'Competition', 'growl', 'AppsoupAPI', 'Permissions', '$filter', '$state', function ($scope, $rootScope, $stateParams, NgTableParams, Competition, growl, AppsoupAPI, Permissions, $filter, $state) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('competitions');
    $scope.application_id = $stateParams.application_id;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getTitleTableParams('title'), {
        getData: function (params) {
            $scope.isLoading = true;
            return Competition.getList($scope.application_id, params._params)
                .then(function (response) {
                    params.total(response.total);
                    params.count(response.per_page);
                    params.page(response.current_page);
                    return response.data;
                })
                .finally(function () {
                    $scope.isLoading = false;
                    $scope.isFind = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.copyCompetition = function (id) {
        Competition.copy(id).then(function (result) {
            let data = result.data;

            if (data.success) {
                growl.success('MODULES.COMPETITION.SUCCESS.COPY_COMPETITION');
                $state.go($state.current, {searchCompetitions: $stateParams.searchCompetitions}, {reload: true});
            } else if (data.error === 'ERROR.COMPETITION_NOT_EXISTS') {
                growl.error('ERROR.COMPETITION_NOT_EXISTS');
            } else {
                growl.error('MODULES.COMPETITION.ERROR.COPY_COMPETITION');
            }
        });
    };

    $scope.remove = function ($event) {
        $event.stopImmediatePropagation();
    };

    $scope.removeCompetition = function (id, index) {
        Competition.remove(id)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.COMPETITION.SUCCESS.DELETE_COMPETITION');
                    $scope.tableParams.data.splice(index, 1);
                } else {
                    growl.error('MODULES.COMPETITION.ERROR.DELETE_COMPETITION');
                }
            });
    };

    $scope.searchCompetitions = function (search) {
        $scope.isFind = true;

        if (angular.isDefinedNotNull(search.from_date)) {
            search.from_date = $filter('date')(search.from_date, 'yyyy-MM-dd');
        }
        if (angular.isDefinedNotNull(search.to_date)) {
            search.to_date = $filter('date')(search.to_date, 'yyyy-MM-dd');
        }

        var find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.isFind = false;
    };

    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.title)) {
            $scope.tableParams._params.title = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.from_date)) {
            $scope.tableParams._params.from_date = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.to_date)) {
            $scope.tableParams._params.to_date = undefined;
        }
    };

}]);

competitionsControllers.controller('CompetitionPageController', ['$scope', '$rootScope', '$locale', '$filter', '$state', '$stateParams', '$translate', 'growl', 'Competition', '$modal', function ($scope, $rootScope, $locale, $filter, $state, $stateParams, $translate, growl, Competition, $modal) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.competition = {};
    $scope.competition.status = 1;
    $scope.editMode = false;
    $scope.upload = undefined;
    $scope.fileUploaded = false;
    $scope.fileErrorSize = false;
    $scope.competition.app_id = $stateParams.application_id;
    $scope.competition.full_description = "<br>";
    $scope.lang = $filter('translate')('LANG');
    if (locales[$scope.lang] && locales[$scope.lang].DATETIME_FORMATS) {
        angular.copy(locales[$scope.lang].DATETIME_FORMATS, $locale.DATETIME_FORMATS);
    }
    var competitionId = $stateParams.competitionId;

    $scope.tinymceOptions = angular.getTinymceOptions($modal);

    if (angular.isDefined($scope.lang) && $scope.lang !== 'en') {
        $scope.tinymceOptions['language'] = $scope.lang;
        $scope.tinymceOptions['language_url'] = '/assets/tinymce/' + $scope.lang + '.js';
    }

    if (angular.isDefined(competitionId)) {
        $scope.editMode = true;
        $rootScope.doingResolve = true;
        Competition.get(competitionId, $stateParams.application_id)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    $scope.fileUploaded = true;
                    $scope.competition = data.competition;
                }
            })
            .catch(function () {
                $state.go('appsoup.application.competitions', {application_id: $stateParams.application_id}, growl.error('ERROR.EMPTY_DATA'));
            })
            .finally(function () {
                $rootScope.doingResolve = false;
            });
    } else {
        var today = new Date();
        $scope.competition.start_date = $filter('date')(today.getTime(), 'yyyy-MM-dd');
        // $scope.competition.end_date = $filter('date')(today.getTime(), 'yyyy-MM-dd');
    }

    $scope.saveCompetition = function () {
        $scope.fileErrorSize = false;
        $scope.$broadcast('show-errors-check-validity');
        if ($scope.competitionForm.$valid) {
            $scope.isLoading = true;

            if (angular.isDefined(competitionId)) {
                $scope.competition.id = competitionId;
            }
            Competition.save($scope.competition, $scope.upload, $scope.editMode)
                .then(function (result) {
                    let data = result.data;

                    if (data.success) {
                        growl.success('MODULES.COMPETITION.SUCCESS.' + ($scope.editMode ? 'EDIT_COMPETITION' : 'NEW_COMPETITION'));
                        $state.go('appsoup.application.competitions');
                    } else {
                        if (data.error.photo && data.error.photo[0] == 'The photo may not be greater than 5120 kilobytes.') {
                            $scope.fileErrorSize = true;
                        }
                        $scope.formErrors = data.error;
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        }
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.competitions');
    };

    $scope.changeDate = function () {
        if (angular.isDefinedNotNull($scope.competition.end_date) && (Date.parse($scope.competition.start_date) > Date.parse($scope.competition.end_date))) {
            $scope.competition.end_date = $scope.competition.start_date;
        }
    };

    $scope.inputErrors = {
        'image': [{type: '$invalid', msg: 'MODULES.LEVELS.ERROR.REQUIRE.IMAGE'}],
        'title': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}],
        'full_description': [{type: '$invalid', msg: 'MODULES.COMPETITION.FORM_ERROR.FULL_CONTENT'}],
        'from_date': [{type: '$invalid', msg: 'FORM.ERRORS.FORMAT'}],
        'to_date': [{type: '$invalid', msg: 'FORM.ERRORS.FORMAT'}]
    };
}])
    .config([
        'datepickerConfig',
        'datepickerPopupConfig',
        function (datepickerConfig, datepickerPopupConfig) {
            angular.extend(datepickerConfig, {});

            angular.extend(datepickerPopupConfig, {});
        }
    ]);

export default competitionsControllers;
